import EditBanner from './EditBanner';

export default EditBanner;
